import * as React from 'react';

import { useLocation, useParams } from 'js/lib/useRouter';

import PromoTemplatePage from 'bundles/promo-template/components/PromoTemplatePage';
import type { DOMAINS } from 'bundles/promo-template/constants/navigation';
import { PromoTemplateDomainProvider } from 'bundles/promo-template/contexts/PromoTemplateDomainContext';
import PromoTemplatePageGuard from 'bundles/promo-template/pages/PromoTemplatePageGuard';

// This mapping is used to map custom paths to the slug used in Contentful
export const PATH_TO_SLUG_MAPPING = {
  '/google-career-certificates': 'google-certificates',
};

type Props = {
  domain: keyof typeof DOMAINS;
  slugOverride?: string;
};

export function getSlug({
  pageSlug,
  pathname,
  slugOverride,
}: {
  pageSlug: string;
  pathname: string;
  slugOverride?: string;
}): string {
  let slug = pageSlug.replace(/\/$/, '');

  if (slugOverride) {
    slug = slugOverride;
  } else if (Object.keys(PATH_TO_SLUG_MAPPING).includes(pathname)) {
    slug = PATH_TO_SLUG_MAPPING[pathname as keyof typeof PATH_TO_SLUG_MAPPING];
  }

  return slug;
}

function PromoTemplatePageWrapper({ domain, slugOverride }: Props) {
  const location = useLocation();
  const params = useParams();
  const domainOverride = location.query.domainOverride as keyof typeof DOMAINS;
  const pathname = location.pathname.replace(/\/$/, '');

  const slug = getSlug({ pageSlug: params?.pageSlug ?? '', pathname, slugOverride });

  return (
    <PromoTemplateDomainProvider domain={domainOverride ?? domain}>
      <PromoTemplatePageGuard>
        <PromoTemplatePage slug={slug} />
      </PromoTemplatePageGuard>
    </PromoTemplateDomainProvider>
  );
}

export default PromoTemplatePageWrapper;
